import React, { useState, useReducer, useEffect } from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import dayjs from "dayjs";
import { get } from "aws-amplify/api";
import DialogActions from "@mui/material/DialogActions";
import Grid from "@mui/material/Grid";
import { I18n } from "aws-amplify/utils";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import currentUserToken from "CurrentUserToken";
import Paper from '@mui/material/Paper';
import Draggable from 'react-draggable';

const reducer = (lastState, action) => {
  if (action.type === "DATA_RECEIVED") {
    const audit = action.value.map((element) => ({
      ...element,
      timestamp: typeof element.timestamp === "number"
        ? dayjs(element.timestamp).format("YYYY-MM-DD HH:mm")
        : element.timestamp,
    }));
    return { audit, fetched: true };
  }
  return lastState;
};

function PaperComponent(props) {
  const nodeRef = React.useRef(null);
  return (
    <Draggable
      nodeRef={nodeRef}
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} ref={nodeRef} />
    </Draggable>
  );
}

function AddCloseDialog({ open, onClose, onSave, alarm, language }) {
  const [state, dispatch] = useReducer(reducer, { audit: [], fetched: false });
  const [remark, setRemark] = useState("");
  const [selectedTypeClose, setSelectedTypeClose] = useState(""); 
  const [selectedTypeCloseId, setSelectedTypeCloseId] = useState(""); // Nuovo stato per l'ID

  useEffect(() => {
    const tlmGetAlarmDescription = async () => {
      try {
        const restOperation = get({
          apiName: "TelemonitoringAPI",
          path: "/pattern/type/all",
          options: {
            headers: {
              "Content-Type": "application/json",
              Authorization: `${await currentUserToken()}`,
            },
            queryParams: { type_name: "CLOSE", language },
          },
        });
        const { body } = await restOperation.response;
        const response = await body.json();
        dispatch({ type: "DATA_RECEIVED", value: response });
      } catch (error) {
        console.error("API Error:", error);
      }
    };

    tlmGetAlarmDescription();
  }, [language]);

  useEffect(() => {
    if (open) {
      setRemark(""); // Reset campo nota
      setSelectedTypeClose(""); // Reset campo descrizione selezionata
      setSelectedTypeCloseId(""); // Reset campo ID selezionato
    }
  }, [open, setRemark]);

  const handleSave = () => {
    onSave(remark, selectedTypeClose, selectedTypeCloseId); // Passa sia la description che l'id
    onClose();
  };

  // Disabilita il pulsante Salva se il campo note è vuoto
  const isSaveDisabled = !(remark.trim());
  const data = alarm && alarm.length > 0 ? alarm[0] : {};

  return (
    <Dialog 
      open={open} 
      onClose={onClose} 
      maxWidth="sm" 
      fullWidth
      PaperComponent={PaperComponent}
    >
      <DialogTitle style={{ cursor: 'move' }}>
        {I18n.get("Close Alarm - ")}
        { alarm.length > 1 ? "Multiple Alarms Selected" : data.original_store + " - " + data.original_equipment + " - " + data.alarm_type_description }
      </DialogTitle>
      
      <DialogContent>
        <Grid container spacing={2} style={{ marginBottom: "10px" }}>
          <Grid item xs={12}>
            <FormControl fullWidth margin="normal">
              <InputLabel>{I18n.get("Select Pattern")}</InputLabel>
              <Select
                fullWidth
                label={I18n.get("Select Pattern")}
                value={selectedTypeClose}
                onChange={(e) => {
                  const selectedPattern = state.audit.find(item => item.description === e.target.value);
                  setSelectedTypeClose(e.target.value);
                  setSelectedTypeCloseId(selectedPattern ? selectedPattern.id : ""); // Salva anche l'id
                }}
              >
                <MenuItem value="" style={{ minHeight: "48px" }}>
                  <em></em>
                </MenuItem>
                {state.audit.map((item) => (
                  <MenuItem key={item.id} value={item.description}>
                    {item.description}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12}>
            <TextField
              label={I18n.get("Note")}
              fullWidth
              multiline
              rows={4}
              value={remark}
              onChange={(e) => setRemark(e.target.value)}
              required
              error={!remark.trim()}
              helperText={!remark.trim() ? I18n.get("Note is required") : ""}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions style={{ cursor: 'move' }}>
        <Button onClick={handleSave} disabled={isSaveDisabled}>{I18n.get("Save")}</Button>
        <Button onClick={onClose}>{I18n.get("Cancel")}</Button>
      </DialogActions>
    </Dialog>
  );
}

export default AddCloseDialog;
